import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/* Services */
import { AuthenticationService } from '../services/authentication.service';

/* View Models */
import { UnlockAccountViewModel } from '../viewmodels/unlock-account-viewmodel';

@Component({
  selector: 'app-unlock-account-confirmation-cmp',
  templateUrl: './account-unlocked-confirmation.component.html',
  styleUrls: ['./account-unlocked-confirmation.scss']
})

export class AccountUnlockedConfirmationComponent implements OnInit {


  unlockedAccountMessage: string;
  token: string;
  unlockAccountViewModel: UnlockAccountViewModel;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute, ){

    this.route.queryParams.subscribe(params => {
        if (params['token'] !== undefined) {
            this.token = params['token'];
            this.unlockedAccountMessage = "Requesting account unlock...";
        } else {
          this.router.navigate(['/login']);
        }
      });
  }



  ngOnInit(): void {
    this.unlockAccountViewModel = new UnlockAccountViewModel();
    this.unlockAccountViewModel.token = this.token;
    /* check if the password reset request is valid */
    this.authenticationService
        .unlockAccount(this.unlockAccountViewModel)
        .subscribe(resp => {
            this.unlockedAccountMessage = resp.message;
    });
  }

  onReturnToLoginPage() {
    this.router.navigate(["/login"]).then( (e) => {
        if (e) {
          console.log("Navigation is successful!");
        } else {
          console.log("Navigation has failed!");
        }
      });
  }
}

